/*require('es6-promise').polyfill()
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use( Vuex )
import { darkMode } from './modules/darkMode'
export default new Vuex.Store({
    modules: {
        darkMode
    }
});*/
require('es6-promise').polyfill();

/*
    Imports Vue and Vuex
*/
import Vue from 'vue'
import Vuex from 'vuex'
import darkMode from './modules/darkMode'
import make from './modules/make'
import model from './modules/model'
import year from './modules/year'
import crm from './modules/crm'

/*
    Initializes Vuex on Vue.
*/
Vue.use( Vuex )

/*
  Exports our data store.
*/
export default new Vuex.Store({
  modules: {
    darkMode,
    make,
    model,
    year,
    crm,

  },
})